import { render } from "./SignupAgree.vue?vue&type=template&id=00f9ebe6&lang=true"
import script from "./SignupAgree.vue?vue&type=script&lang=js"
export * from "./SignupAgree.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__